import axios from "axios";
import { getProvider, royaltyBpsFromFee } from "./web3_api";
import { factory_ABI, factory_Address, nft_Minting_ABI_1156, market_Place_Address, market_Place_Abi, nft_Minting_ABI_721, BUSD_Address, BUSD_Abi, NFT_Validator_Address, NFT_Validator_ABI, AirDropNFT_Address, AirDropNFT_ABI, AirDropNFT_ABIv2, TestUSD_Address, TestUSD_ABI, nft_Display_ABI_721 } from "./ABI"
import Web3 from "web3";



export const get_Factory_contract = async () => {
  const provider = await getProvider();
  const contract = new provider.eth.Contract(factory_ABI, factory_Address);
  // console.log(contract)
  return contract;
}

export const get_all_nft_contract_ = async (nft_address) => {
 try {
  const provider = await getProvider();
  const contract = new provider.eth.Contract(nft_Display_ABI_721, nft_address);
  return contract;
 } catch (error) {
  
 }
}


// for 1156 type nft
export const get_Minting_contract_1155 = async (nft_address) => {
  const provider = await getProvider();
  const contract = new provider.eth.Contract(nft_Minting_ABI_1156, nft_address);
  // console.log(contract)
  return contract;
}


// for 721 type nft
export const get_Minting_contract_721 = async (nft_address) => {
  const provider = await getProvider();
  const contract = new provider.eth.Contract(nft_Minting_ABI_721, nft_address);
  // console.log(contract)
  return contract;
}


export const get_Marketplace_contract = async (nft_address) => {
  try {
    const provider = await getProvider();
    const contract = new provider.eth.Contract(market_Place_Abi, market_Place_Address);
    // console.log(contract)
    return contract;
  } catch (error) {
    console.log(error)
  }
}

export const get_Validator_NFT_contract = async (nft_address) => {
  try {
    const provider = await getProvider();
    const contract = new provider.eth.Contract(NFT_Validator_ABI, NFT_Validator_Address);
    // console.log(contract)
    return contract;
  } catch (error) {
    console.log(error)
  }
}

export const get_Airdrop_NFT_contract = async () => {
  try {
    const provider = await getProvider();
    const contract = new provider.eth.Contract(AirDropNFT_ABI, AirDropNFT_Address);
    return contract;
  } catch (error) {
    console.log(error)
  }
}

export const get_Airdrop_NFT_contract_by_address = async (address) => {
  try {
    const provider = await getProvider();
    const contract = new provider.eth.Contract(AirDropNFT_ABIv2, address);
    return contract;
  } catch (error) {
    console.log(error)
  }
}

export const get_ERC20_contract = async (tokenAdd) => {
  try {
    const provider = await getProvider();
    const contract = new provider.eth.Contract(BUSD_Abi, tokenAdd);
    return contract;
  } catch (error) {
    console.log(error)
  }
}


/** Approves the marketplace for exactly `amount` (wei) of `tokenAddress`. */
export const Approve = async (user, tokenAddress, amount) => {
  try {
    const web3 = await getProvider();
    const contract = new web3.eth.Contract(BUSD_Abi, tokenAddress);
    const data = await contract.methods
      .approve(market_Place_Address, amount)
      .send({ from: user });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const Allow = async (user, tokenAddress) => {
  try {
    const web3 = new Web3(window.ethereum);
    console.log(tokenAddress)
    const contract = new web3.eth.Contract(BUSD_Abi, tokenAddress);
    const data = await contract.methods.allowance(user, market_Place_Address).call();
    console.log("Token allownce",data)
    return data;
  } catch (error) {
    console.log(error);
  }
};

/** Approves the marketplace for `amount` (wei) of an ERC-20 unless the allowance already covers it. */
export const ensureAllowance = async (user, tokenAddress, amount) => {
  const allowance = await Allow(user, tokenAddress);
  if (Web3.utils.toBN(String(allowance || 0)).lt(Web3.utils.toBN(String(amount)))) {
    await Approve(user, tokenAddress, amount);
  }
};

/** Approves the marketplace for every token of an NFT contract, once per wallet and contract. */
export const ensureNftApproval = async (user, nftContract) => {
  const approved = await nftContract.methods.isApprovedForAll(user, market_Place_Address).call();
  if (!approved) {
    await nftContract.methods.setApprovalForAll(market_Place_Address, true).send({ from: user });
  }
};

/** Testnet only: the tUSD faucet token. */
export const get_TestUSD_contract = async () => {
  const provider = await getProvider();
  return new provider.eth.Contract(TestUSD_ABI, TestUSD_Address);
};

/**
 * The address a factory transaction deployed, from its `CollectionCreated` event.
 * Replaces taking the last entry of `getUserNFTContracts`, which a second
 * creation by the same wallet can race.
 */
export const createdCollectionAddress = (receipt) => {
  const event = receipt.events && receipt.events.CollectionCreated;
  const first = Array.isArray(event) ? event[0] : event;
  return first ? first.returnValues.collection.toLowerCase() : undefined;
};

/** Token IDs a transaction minted, from the standard Transfer / TransferSingle events. */
export const mintedTokenIds = (receipt) => {
  const zero = "0x0000000000000000000000000000000000000000";
  const ids = [];
  for (const name of ["Transfer", "TransferSingle"]) {
    const found = receipt.events && receipt.events[name];
    const list = Array.isArray(found) ? found : found ? [found] : [];
    for (const event of list) {
      if (event.returnValues.from === zero) {
        ids.push(String(event.returnValues.tokenId ?? event.returnValues.id));
      }
    }
  }
  return ids;
};

/**
 * The royalty a new NFT contract gets, from its database collection (D1: the
 * collection holds `fee` and `royalty_address`, as legacy `addCollection` did).
 * Falls back to no royalty when the collection cannot be read.
 */
export const collectionRoyalty = async (collectionID, fallbackReceiver) => {
  try {
    if (!collectionID) return { receiver: fallbackReceiver, bps: 0 };
    const res = await axios.get(`${window.apiURL}/collectionbyid/${collectionID}`);
    const collection = res.data || {};
    return {
      receiver: collection.royalty_address || collection.Creator || fallbackReceiver,
      bps: royaltyBpsFromFee(collection.fee),
    };
  } catch (error) {
    console.log(error);
    return { receiver: fallbackReceiver, bps: 0 };
  }
};
